// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { router } from "./router";
import store from "@/store/store";

import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);

Vue.config.productionTip = false;

// 引入外部svg图片
import "./icons";

import "@/utils/localStorage";

Vue.config.productionTip = false;

/* ============== 引入view start ==============*/
// 引入view UI
import ViewUI from "view-design";
// 引入主题
import "../my-theme/index.less";
Vue.use(ViewUI); // 使用ViewUI
/* ============== 引入view start ==============*/

/* ============== 引入animate start ==============*/
import "../static/css/animate.min.css";
/* ============== 引入animate end ==============*/

// 引入ant-design-vue
import Ant from '@/utils/ant'
Vue.use(Ant)
/* ============== 引入axios start ==============*/
// 引入axios
import axios from "axios";
Vue.prototype.$http = axios;
/* ============== 引入axios start ==============*/

/* ============== 引入clipboard,这是复制插件 start ==============*/
import clipboard from "clipboard"; // 引入clipboard,这是复制的插件
Vue.prototype.clipboard = clipboard; //注册到vue原型上
/* ============== 引入clipboard,这是复制插件 start ==============*/


/*******引入文件下载打包工具JSZip和客户端文件保存工具FileSaver*****/ 
import JSZip from 'jszip'
import FileSaver from 'file-saver'

/* ============== 引入地址级联选择插件 start ==============*/
// 引入地址级联选择插件-web
import VDistpicker from "v-distpicker";
Vue.component("v-distpicker", VDistpicker);

import VueAreaLinkage from 'vue-area-linkage'
Vue.use(VueAreaLinkage)

// 引入地址级联选择插件-app
import CascadingPicker from "cascading-picker";
import "cascading-picker/dist/CascadingPicker.css";

// 插件使用时提供一个name属性用于更改组件注册的名称，默认名称为CascadingPicker，主要是为了避免和其他ui库命名冲突
// Vue.use(CascadingPicker, {
//   name: 'AlanCascadingPicker' // 此时组件注册后的名称为AlanCascadingPicker
// });
Vue.use(CascadingPicker);
/* ============== 引入地址级联选择插件 start ==============*/

/* 引入动画插件 start */
import { WOW } from "wowjs";
Vue.prototype.WOW = WOW;
/* 引入动画插件 end */

// 是否是IOS
// 判断设备为 ios
Vue.prototype.isIos = function() {
  var u = navigator.userAgent;
  if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
    return true;
  }
  return false;
};

// 是否是IE 11及以下或者其他(其他里包括IE edge)
Vue.prototype.isIE = function() {
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    // 是IE浏览器
    return true;
  } else {
    // 不是IE浏览器
    return false;
  }
};

/**
 * object赋值处理 还要处理数组
 */
// 以第一个参数的值为标准，将第二个参数的值赋值到第一个参数上（如果第二个参数为空，则不进行赋值）
Vue.prototype.loopObj = function(loopParam, setParam) {
  for (const key in loopParam) {
    console.log(loopParam, key);
    if (loopParam[key] && typeof loopParam[key] === "object") {
      this.loopObj(loopParam[key], setParam[key]);
    } else {
      // 如果有值则进行覆盖
      console.log(key, "setParam[key]", setParam[key]);
      setParam[key] && (loopParam[key] = setParam[key]);
    }
  }
};


Vue.prototype.deepCopy = function (obj, isQuote) {
  let parents = []
  let children = []

  function _clone (obj) {
    if (obj === null) return null;
    if (typeof obj !== 'object') return obj;
    if (obj instanceof Date) return new Date(obj);
    if (obj instanceof RegExp) return new RegEcp(obj);
    if (obj._isAMomentObject) return obj; // 判断moment时间对象

    let newObj = new obj.constructor()

    // 解决循环引用
    if (isQuote) {
      let index = parents.indexOf(obj)

      if (index === -1) return children[index];
      parents.push(obj)
      children.push(children)
    }

    for (let i in obj) {
      if (obj.hasOwnProperty(i)) {
        newObj[i] = _clone(obj[i])
      }
    }

    return newObj
  }

  return _clone(obj)
}


Vue.prototype.debounce = function (fn, delay) {
  let timer = null // 由于还需要一个变量来保存计时，考虑维护全局纯净，借助闭包来实现
  return (...args) => {
    if (timer) {
      clearTimeout(timer) // 在计时时间内再次触发，停止定时
    }

    // 第一次触发定时 或者 之后重新开始定时
    timer = setTimeout(() => {
      fn.apply(this, args)
      clearTimeout(timer)
    }, delay)
  }
}

/* ================================OSS============================================= */
// 获取随机数
Vue.prototype.getRandom = function(digit) {
  let charactors = "1234567890";
  let value = "",
    i;
  for (let j = 1; j <= digit; j++) {
    i = parseInt(Math.random() * 10);
    value = value + charactors.charAt(i);
  }
  return value;
};

let OSS = require("ali-oss");
Vue.prototype.OSSClient = new OSS(process.env.OSSParam);

// 上传oss文件
Vue.prototype.ossUpload = function(localFile, callback) {
  let fileName = localFile.name;
  let year = new Date().getFullYear();
  let month = new Date().getMonth() + 1;
  let date = new Date().getDate();
  let directory = `${year}/${month >= 10 ? month : "0" + month}/${
    date >= 10 ? date : "0" + date
  }`;
  let ossFileName = new Date().pattern("yyyyMMddhhmmssS");
  let random = this.getRandom(3);

  let path = directory + "/" + ossFileName + random + ".";
  let pathFile = path + fileName.split(".")[fileName.split(".").length - 1];
  let _this = this;

  async function put() {
    try {
      let options = {
        headers: {
          "Content-Disposition":
            "attachment;filename=" + encodeURIComponent(fileName)
          // "Content-Encoding":"UTF-8"
        }
      };
      let result = await Vue.prototype.OSSClient.put(
        pathFile,
        localFile,
        options
      );
      callback(result);
    } catch (err) {
      _this.$Message.error("上传oss服务器失败:" + err);
      callback(null);
    }
  }
  put();
};

// 批量下载zip
Vue.prototype.ossBatchDownload = function (zipname, ossFiles, callback) {
  const zip = new JSZip()
  const promises = []
  const same = new Map()
  ossFiles.forEach(item => {
    if (!item.ossUrl) {
      return
    }
    const promise = new Promise((resolve) => {
      // 将文件转成blob格式
      var xhr = new XMLHttpRequest()
      xhr.open('GET', `${item.ossUrl}?timestamp=${new Date().getTime()}`, true)
      // 指定接受类型
      xhr.responseType = 'blob'
      xhr.onload = function (oEvent) {
        // blob对象，Blob(52036) {size: 52036, type: "image/jpeg"}
        var blob = xhr.response
        let filename = item.filename
        // 若文件名没有后缀则从ossUrl中取文件后缀
        if (filename.lastIndexOf('.') < 0) {
          filename += item.ossUrl.substring(item.ossUrl.lastIndexOf('.'))
        }
        if (same.has(item.filename)) {
          let index = same.get(item.filename)
          const name = filename.substring(0, filename.lastIndexOf('.'))
          const suffix = filename.substring(filename.lastIndexOf('.') + 1)
          filename = name + '(' + index + ').' + suffix
          same.set(item.filename, ++index)
        } else {
          same.set(item.filename, 1)
        }
        zip.file(filename, blob, { blob: true }) // 逐个添加文件
        resolve()
      }
      xhr.send()
    })
    promises.push(promise)
  })

  Promise.all(promises).then(() => {
    zip.generateAsync({ type: 'blob' }).then(content => { // 生成二进制流
      FileSaver.saveAs(content, `${zipname}.zip`) // 利用file-saver保存文件
      callback && callback()
    })
  })
}

/* ================================= ajax封装 start ========================================*/
//在main.js设置全局的请求次数，请求的间隙
axios.defaults.retry = 1;
axios.defaults.retryDelay = 1000;
axios.defaults.timeout = 1000 * 60;

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve();
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function() {
    return axios(config);
  });
});

/** axios请求封装
 * 请求参数
 option <对象>
 method 请求方式
 url 请求路径
 data 请求数据
 success 成功的回调函数
 * 调用
 this.sendMessage({
          method: 'get',
          url: '',
          headers: {
            'Content-Type': "application/json;charset=utf-8"
          },
          data: '',
          tip: '', // false-显示loading, true-隐藏loading（默认）
          successCallback: ()=>{},
          failCallback: ()=>{},
          errCallback: ()=>{}
      }, (result)=>{
          console.log(result)
      }, notCode // 如果为真则不进行code判断)
 */
Vue.prototype.sendMessage = function(option, callback, notCode) {
  const that = this;

  const token = store.state.token;

  let options = Object.assign(
    {
      method: option.method || "post",
      tip: true // 如错误code提示信息
    },
    option
  );

  let headers = {
    /*'Discount-Platform-Code': 'RZX',
    'Discount-Platform-Request-Source': 'front',*/
    "X-Requested-With": "XMLHttpRequest",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    "x-form-id": "mob-form",
    t: new Date().getTime()
  };
  option.headers ? Object.assign(headers, option.headers) : "";
  options.headers = headers;

  options.url = process.env.API_ROOT + option.url;

  // console.log('axios请求', options);
  axios(options)
    .then(
      result => {
        options.tip ? that.removeLoading() : "";
        // console.log("result", result, 'options.url:', options.url);

        if (!notCode) {
          if (
            result.data.code == "error401" ||
            result.data.code == "SESSION_TIME_OUT"
          ) {
            options.failCallback ? options.failCallback() : "";

            that.exitLogin(); // 退出登录
          }

          if (
            result.data.code != "ACK" &&
            (result.data.message || result.data.remark)
          ) {
            if (options.tip) {
              this.hasOwnProperty("loading") ? (this.loading = false) : "";
              this.$Message.error(result.data.message || result.data.remark);
            }

            options.errCallback ? options.errCallback(result) : "";
          }
        }

        if (result.data.code == "ACK") {
          options.successCallback ? options.successCallback(result) : "";
        }

        callback ? callback(result) : "";
      },
      res => {
        if (options.tip) {
          that.removeLoading();
          this.hasOwnProperty("loading") ? (this.loading = false) : "";
        }

        console.log("********res： " + option.url, res);
        console.log("res.response:", res.response);

        let resData = res.response && res.response.data;
        if (resData && resData.code == "SESSION_TIME_OUT") {
          that.exitLogin(); // 退出登录
        } else {
          // 处理资讯已报废
          if (option.url === '/web/inforManage/getInfoById' && res.response.status === 500 && res.response.data.code === "COMMON_ERROR") {
            this.$Message.error('您当前查看的资讯已作废');
          }
          throw res;
        }
      }
    )
    .catch(err => {
      console.log(err, '===== catch');
      options.errCallback ? options.errCallback(err) : "";
    });
};

/** 其他请求
 * 调用
 * // tip展示显示loading无效
 this.sendOther({
          url: '',
          data: '',
          method: '',
      }, (result)=>{
          // console.log("ack回调", result);
      }, (result)=>{
          // console.log("其他回调", result);
      })
 */
Vue.prototype.sendOther = function(option, ack, callback) {
  this.hasOwnProperty("loading") ? (this.loading = true) : "";

  this.sendMessage(option, result => {
    // console.log('other', option, option.tip);
    this.hasOwnProperty("loading") ? (this.loading = false) : "";

    if (result.data.code == "ACK") {
      ack ? ack(result) : "";
    } else {
      callback ? callback(result) : "";
    }
  });
};

// !tip:对于loading的展示显示无效
Vue.prototype.sendPut = function(option, ack, callback) {
  option.method = "put";
  this.sendOther(option, ack, callback);
};

Vue.prototype.sendPost = function(option, ack, callback) {
  option.method = "post";
  this.sendOther(option, ack, callback);
};

/** get请求
 * 调用
 * tip：展示显示loading无效
 this.sendGet({
          url: `/sysParam/${row.id}`,
          data: ""
      }, (result)=>{
          // console.log("ack回调", result);
      }, (result)=>{
          // console.log("其他回调", result);
      })
 */
Vue.prototype.sendGet = function(option, ack, callback) {
  option.method = "get";

  // 对get请求参数进行拼接
  if (option.data) {
    var url = "";
    for (const key in option.data) {
      option.data[key] ? (url += "&" + key + "=" + option.data[key]) : "";
    }
    option.url += "?" + url.slice(1);
    option.url = encodeURI(option.url);
    option.data = "";
  }
  this.sendOther(option, ack, callback);
};

/** delete请求方式 【一般用于删除接口】
 * 调用
 this.sendDel('确认删除该记录吗?', {
          url:`/sysParam/${row.id}`,
          data: ""
      }, (result)=>{
          // console.log("ack回调", result);
          // this.getList();
      }, (result)=>{
          // console.log("其他回调", result);
      })
 */
// 删除接口
Vue.prototype.sendDel = function(option, ack, callback) {
  option.method = 'delete'
  this.sendOther(option, ack, callback)
}
// Vue.prototype.sendDel = function(msg, option, ack, callback) {
//   this.$confirm(msg, "提示", {
//     type: "warning"
//   })
//     .then(() => {
//       this.hasOwnProperty("loading") ? (this.loading = true) : "";

//       option.method = "delete";

//       this.sendMessage(option, result => {
//         this.hasOwnProperty("loading") ? (this.loading = false) : "";

//         if (result.data.code == "ACK") {
//           this.$message({
//             message: result.data.message || "删除成功",
//             type: "success"
//           });

//           ack ? ack() : "";
//         } else {
//           callback ? callback() : "";
//         }
//       });
//     })
//     .catch(() => {});
// };

/** 表单提交【一般使用在  新增、更新接口上】
 * 调用
 * this.sendSubmit('表单ref的名字','确认提交吗?', {
          url:`/sysParam/${row.id}`,
          method: 'post'
          data: ""
      }, (result)=>{
          // console.log("ack回调", result);
          // this.getList();
      }, (result)=>{
          // console.log("其他回调", result);
      })
 */
Vue.prototype.sendSubmit = function(formName, msg, option, ack, callback) {
  this.$refs[formName].validate(valid => {
    if (valid) {
      this.$confirm(msg, "提示", {})
        .then(() => {
          this.hasOwnProperty("addLoading") ? (this.addLoading = true) : "";

          this.sendMessage(option, result => {
            this.hasOwnProperty("addLoading") ? (this.addLoading = false) : "";

            if (result.data.code == "ACK") {
              this.$message({
                message: result.data.message,
                type: "success"
              });

              this.$refs[formName].resetFields();

              ack ? ack() : "";
            } else {
              callback ? callback() : "";
            }
          });
        })
        .catch(() => {
          this.hasOwnProperty("addLoading") ? (this.addLoading = false) : "";
        });
    } else {
      console.log("error submit!!");
      return false;
    }
  });
};
/* ================================= ajax封装 end ========================================*/

/* ================================= 广告位 & 地址管理 start ========================================*/
// 针对不同环境配置rzline地址
Vue.prototype.rzlineUrl = function() {
  let url = "";

  console.log(process.env.EVN_CONFIG, "url");

  switch (process.env.EVN_CONFIG) {
    case "dev":
      url = "http://localhost/qcServer/";
      break;

    case "test":
      url = "https://uat.rzline.com/";
      break;

    case "uat":
      url = "https://uat.rzline.com/";
      break;

    case "prod":
      url = "https://rzline.com/";
      break;
  }
  return url;
};

// 广告位链接跳转
Vue.prototype.toLinkUrl = function(url) {
  // window.location.href = url
  url ? window.open(url, "_blank") : "";
};

// 广告位获取
Vue.prototype.getAdvertimg = function(code, callback) {
  this.sendGet(
    {
      url: `/web/advert/advertimg/query/${code}`
    },
    result => {
      callback(result.data.data);
    }
  );
};

// 本地图片地址
Vue.prototype.imgUrl = function(name) {
  return require("@/assets/img/" + name);
};

// 后台图片地址生成
Vue.prototype.getImgUrl = function(name, noCache) {
  if (!name) {
    return name;
  }

  let url;
  if (name.indexOf("http") < 0) {
    url =
      (process.env.API_ROOT || this.rzlineUrl()) +
      "/web/common/image?fileName=" +
      name +
      (noCache ? "" : "&isGoods=1");
  } else {
    url = name;
  }
  return url;
};

// 后台文件地址生成 --- 如果带有http的则不生成后台的文件地址
Vue.prototype.getFileUrl = function(name) {
  let url;
  if (name.indexOf("http") < 0) {
    url =
      (process.env.API_ROOT || this.rzlineUrl()) +
      "/web/common/downloadFile?fileName=" +
      name;
  } else {
    url = name;
  }
  return url;
};

/* ================================= 广告位 & 地址管理 end ========================================*/

/* ================================= 登录 start ========================================*/
/** 获取用户信息 **/
Vue.prototype.getUserInfoMain = function(options) {
  // console.log(localStorage.getItem("isLogin"))
  if (!localStorage.getItem("isLogin")) {
    return false;
  }

  // this.sendOther(
  this.sendGet(
    {
      // url: "/web/sysUser/getUserInfoByUserId",
      url: "/trade-center/sys-user/find-login-user",
      // data: { userId: store.state.userId },
      tip: false
    },
    result => {
      // 获取用户信息
      store.state.userId = result.data.data.userId;
      store.state.userPhone = result.data.data.userName;
      store.state.user.userInfo = result.data.data;
      localStorage.setItem("loginParam", JSON.stringify(store.state));

      customQyInit();

      if (this.$route.params.toRecharge) {
        store.state.showPopups = false;
        store.state.loginStatus = false;
        this.$router.push({
          name: "DiscountTrends",
          params: { toRecharge: true }
        });
        return;
      }

      if (options) {
        options.ack ? options.ack() : "";
      }
    }
  );
};

// 登录
Vue.prototype.funLogin = function(options) {
  localStorage.removeItem("loginParam"); // 清除之前的用户信息

  localStorage.setItem(
    "isLogin",
    JSON.stringify({
      isLogin: true,
      time: new Date().getTime()
    })
  );

  this.getUserInfoMain(options); // 登录成功后，获取用户信息
};

// 判断是否登录
Vue.prototype.fungetLogin = function() {
  let getLogin = JSON.parse(localStorage.getItem("isLogin"));
  getLogin = getLogin ? getLogin.isLogin : "";

  localStorage.getItem("loginParam") ? "" : (getLogin = "");

  !getLogin ? this.handleExitLogin() : "";

  // console.log('判断是否登录 fungetLogin', getLogin);
  return getLogin;
};

// 退出登录、删除信息
Vue.prototype.handleExitLogin = function() {
  localStorage.removeItem("isLogin");
  localStorage.removeItem("loginParam");

  store.state.userId = "";
  store.state.user.userInfo = {
    headPhoto: ""
  };
  // 退出登录之后清除红包的样式
  store.state.redType = "";
  store.state.redOldStatus = false;
  store.state.redStatus = false;
  store.state.eventCount = 0;
  store.state.orderCount = 0;
  store.state.orderCountSP = 0;
  store.state.orderCountYP = 0;
};

// 退出登录
Vue.prototype.exitLogin = function(isTrue) {
  // console.log('route.name',this.$route.name)
  this.addLoading();

  this.sendGet({ url: "/web/auth/logout" });

  this.handleExitLogin(); // 退出登录、删除信息
  this.$Message.success("退出成功");

  customQyOff(); // 销毁七鱼用户

  // 退出成功之后清除银行签约存储的已填写的签约数据
  for (let item in localStorage) {
    if (/^signBank*/.test(item)) {
      console.log(item, "remove");
      localStorage.removeItem(item);
    }
  }

  // 如果是在银票快贴的路由则重新创建银票快贴组件
  if (this.$route.name == "ApplicationDiscount") {
    this.reload();
  }

  // 如果是在商票速融的路由则重新创建商票速融组件
  if (this.$route.name == "BusinessTicketDiscount") {
    this.reload();
  }

  if (this.$route.meta.login) {
    this.$router.push({ name: "Home", params: { login: true } }); // 路由跳转传递参数
  } else {
    this.showLoginPopus();
  }
};

Vue.prototype.showLoginPopus = function() {
  store.state.showPopups = true;
  store.state.loginStatus = true;
  store.state.tipStatus = false;
};

// 判断当前用户是否参与用户红包的活动
Vue.prototype.activity = function(userId) {
  this.sendGet(
    {
      url: "/web/activity/user/login",
      data: {
        userId: userId
      }
    },
    result => {
      console.log(result.data.data, "result");
      store.state.redType = "";
      if (result.data.data.length > 0) {
        // 可能有红包活动
        let newRedList = result.data.data.filter(
          item => item.code === "LOGIN_V3016_NEW_USER"
        );
        let oldRedList = result.data.data.filter(
          item => item.code === "LOGIN_V3016_OLD_USER"
        );
        console.log(newRedList, oldRedList);
        if (oldRedList.length > 0) {
          // 老用户红包
          store.state.redType = 2;
          store.state.redAmount = oldRedList[0].amountGive;
          store.state.redContent = oldRedList[0].content;
          setTimeout(function() {
            console.log("setTimeout");
            store.state.redPkId = oldRedList[0].pkId;
            store.state.showPopups = true;
            store.state.redOldStatus = true;
            store.state.redStatus = false;
            store.state.drawDownOldStatus = true;
            store.state.drawUpOldStatus = false;
            /*setTimeout(function () {
            _this.$store.state.drawDownOldStatus = false;
            _this.$store.state.drawUpOldStatus = true;
          }, 1000)*/
          }, 1000);
        } else if (newRedList.length > 0) {
          // 新用户红包
          store.state.redType = 1;
          store.state.redAmount = newRedList[0].amountGive;
          setTimeout(function() {
            console.log("setTimeout");
            store.state.showPopups = true;
            store.state.redStatus = true;
            store.state.redOldStatus = false;
            // 得到红包
            Vue.prototype.getRedAmount(newRedList[0].pkId);
            setTimeout(function() {
              store.state.drawDownStatus = false;
              store.state.drawUpStatus = true;
            }, 1000);
          }, 1000);
        }
        // console.log(result.data.data.filter(item => item.code === 'LOGIN_V3016_OLD_USER'), "lao");
        // console.log(result.data.data.filter(item => item.code === 'LOGIN_V3016_NEW_USER'), "xin");
      }
    }
  );
};

// 获得红包
Vue.prototype.getRedAmount = function(activityId) {
  this.sendOther({
    url: "/web/activity/join/" + activityId,
    data: {
      userId: store.state.userId
    },
    successCallback: result => {
      store.state.drawDownOldStatus = false;
      store.state.drawUpOldStatus = true;
      console.log(result.data.data, "result");
      store.state.redType = "";
      Vue.prototype.getUserInfoMain(); // 获取用户信息
    },
    errCallback: function() {
      store.state.redType = "";
      store.state.redOldStatus = false;
      store.state.redStatus = false;
      store.state.showPopups = false;
      Vue.prototype.getUserInfoMain(); // 获取用户信息
    }
  });
};

/* ================================= 登录 end ========================================*/

/* ================================= date start ========================================*/
/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * eg:
 * (new Date()).pattern("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * (new Date()).pattern("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
 * (new Date()).pattern("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
 * (new Date()).pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
 * (new Date()).pattern("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
Date.prototype.pattern = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, //小时
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  var week = {
    "0": "/u65e5",
    "1": "/u4e00",
    "2": "/u4e8c",
    "3": "/u4e09",
    "4": "/u56db",
    "5": "/u4e94",
    "6": "/u516d"
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? "/u661f/u671f"
          : "/u5468"
        : "") + week[this.getDay() + ""]
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};

/** 根据给定的时间戳，返回【时分秒】
 * 参数
 time 时间戳，单位 毫秒
 hSplit 时的类型 （如 时 || ：）
 mSplit 分的类型 （如 分 || ：）
 sSplit 秒的类型 （如 秒 || 空""）
 symbol 给定时间戳小于0的前缀符号
 isSec true-过滤秒
 isZero true-时分秒小于10添加0
 * 调用
 timestamp({
              time: new Date().getTime() - 1000 * 60 * 56 * 2 - new Date().getTime(),
              hSplit: "时",
              mSplit: "分",
              sSplit: "秒",
              symbol: "超时",
              isSec: true
          });
 */
Vue.prototype.timestamp = function(option) {
  let options = Object.assign(
    {
      hSplit: ":",
      mSplit: ":",
      sSplit: " ",
      symbol: "超时",
      isZero: true,
      isSec: false
    },
    option
  );

  var date = Math.abs(options.time); // 将时间转化为正数

  // 将时间差 转换成 天 时 分 秒
  var d = parseInt(date / (1000 * 60 * 60 * 24)); // 天

  var h = parseInt((date / (1000 * 60 * 60)) % 24); // 时
  d > 0 ? (h = h + d * 24) : "";

  var m = parseInt((date / (1000 * 60)) % 60); // 分

  var s = parseInt((date / 1000) % 60); // 秒

  if (options.isZero) {
    h < 10 ? (h = "0" + h) : "";
    m < 10 ? (m = "0" + m) : "";
    s < 10 ? (s = "0" + s) : "";
  }

  return (
    (options.time >= 0 ? "" : options.symbol) +
    (h != "00" ? h + options.hSplit : "") +
    m +
    options.mSplit +
    (options.isSec ? "" : s + options.sSplit)
  );
};

/**为了兼容IE对日期格式的处理，IE不支持格式中有-
 *
 * */
Vue.prototype.compatibilityIEDate = function(data) {
  // console.log(JSON.stringify(data), 'indexof', data.indexOf('-'));
  return data && JSON.stringify(data).indexOf("-") > -1
    ? data.toString().replace(/-/gi, "/")
    : data;
};

/**
 * !  日期的加法 DateAdd
  *   参数:interval,字符串表达式，表示要添加的时间间隔. 
  *   参数:number,数值表达式，表示要添加的时间间隔的个数. 
  *   参数:date,时间对象.可以指定日期 也可以是当前日期，默认是当前日期
  *   返回:新的时间对象. 
  *   this.DateAdd('d',22,'2022-4-12') 
  *   返回'2022/5/4' *****
*/

Vue.prototype.DateAdd = function(interval, no, date ) {
  let number = Number(no)
  if (!date) {
    let dd = new Date()
    date= dd.toLocaleDateString()
  }
  let Dt = new Date(date)
  let str = ''
  switch (interval) {
    case "y": {
      Dt.setFullYear(Dt.getFullYear() + number);
      str = Dt;
      break;
    }
    case "q": {
      Dt.setMonth(Dt.getMonth() + number * 3);
      str = Dt;
      break;
    }
    case "m": {
      Dt.setMonth(Dt.getMonth() + number);
      str = Dt;
      break;
    }
    case "w": {
      Dt.setDate(Dt.getDate() + number * 7);
      str = Dtstr = Dt;
      break;
    }
    case "d": {
      Dt.setDate(Dt.getDate() + number);
      str = Dt;
      break;
    }
    case "h": {
      Dt.setHours(Dt.getHours() + number);
      str = Dt;
      break;
    }
    case "m": {
      Dt.setMinutes(Dt.getMinutes() + number);
      str = Dt;
      break;
    }
    case "s": {
      Dt.setSeconds(Dt.getSeconds() + number);
      str = Dt;
      break;
    }
    default: {
      Dt.setDate(d.getDate() + number);
      str = Dt;
      break;
    }
  }
  return str.toLocaleDateString()
}
/* ================================= date end ========================================*/

/* ================================= 金额 start ========================================*/
// 数字转换成货币格式 封装
// number 数字
// places 小数位
// sybol 货币前缀
// thousand 货币以什么分割
// decimal 以什么跟小数分割
// formatMoney(value, 2, "￥", ",", ".")
Vue.prototype.formatMoney = function(
  number,
  places,
  symbol,
  thousand,
  decimal
) {
  places = !isNaN((places = Math.abs(places))) ? places : 2;
  symbol = symbol !== undefined ? symbol : "￥";
  thousand = thousand || ",";
  decimal = decimal || ".";

  if (number) {
    var negative = number < 0 ? "-" : "",
      i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "",
      j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      symbol +
      negative +
      (j ? i.substr(0, j) + thousand : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) +
      (places
        ? decimal + (Math.abs(number - i).toFixed(places) + "").slice(2)
        : "")
    );
  } else {
    return symbol + parseFloat(0).toFixed(places);
  }
};
// 数字 转换成 货币大写 格式 【 1000 -> 壹仟元整 】
Vue.prototype.digitUppercase = function(n) {
  n = parseFloat(n);

  if (n) {
    var fraction = ["角", "分"];
    var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
    var unit = [
      ["元", "万", "亿"],
      ["", "拾", "佰", "仟"]
    ];
    var head = n < 0 ? "欠" : "";
    n = Math.abs(n);
    var s = "";

    var dec = n.toString().split(".")[1] || [];

    for (var i = 0; i < dec.length; i++) {
      s += (digit[dec[i]] + fraction[i]).replace(/零./, "");
    }

    s = s || "整";
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
      var p = "";
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
    }
    return (
      head +
      s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整")
    );
  } else {
    return "";
  }
};
/* ================================= 金额 end ========================================*/

/* ================================= 数字 start ========================================*/
/**
 * 自定义数值转成指定小数位数
 * num 数值
 * digit 小数位数，默认2
 */
function toDecimal(digit) {
  var num = this;
  digit = digit == undefined ? 2 : digit;
  typeof num == "string" ? (num = parseFloat(num)) : ""; // this如果是字符串，则转成数字类型
  typeof digit == "string" ? (digit = parseFloat(digit)) : ""; // 参数digit如果是字符串，则转成数字类型

  // 如果为NaN抛出异常
  if (isNaN(num)) return "";

  // 判断小数位数
  var n = 1;
  if (digit) {
    for (var i = 0; i < digit; i++) {
      n *= 10;
    }
  }

  // 数值进行四舍五入计算
  var fixNum = (Math.round(num * n) / n).toString();

  // 小数位数不足时，补全
  if (digit != 0 && fixNum.indexOf(".") == -1) {
    fixNum += ".";
  }
  while (digit != 0 && fixNum.split(".")[1].length < digit) {
    fixNum += "0";
  }

  // 此处不能返回 parseFloat(fixNum)，返回 parseFloat(fixNum) 会将 2.00 变成 2.
  return fixNum;
}
Number.prototype.toFixed = toDecimal;
String.prototype.toFixed = toDecimal;

// +-*/
// 加法
Number.prototype.add = function(arg) {
  var r1, r2, m;
  try {
    r1 = this.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }

  try {
    r2 = arg.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }

  m = Math.pow(10, Math.max(r1, r2));

  return Math.round(this * m + arg * m) / m;
};

// 减法
Number.prototype.sub = function(arg) {
  return this.add(-arg);
};

// 乘法 0.002.mul(100) = 0.2
Number.prototype.mul = function(arg) {
  var m = 0,
    s1 = this.toString(),
    s2 = arg.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}

  try {
    m += s2.split(".")[1].length;
  } catch (e) {}

  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
};
// 除法
Number.prototype.div = function(arg) {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = this.toString().split(".")[1].length;
  } catch (e) {}
  try {
    t2 = arg.toString().split(".")[1].length;
  } catch (e) {}

  r1 = Number(this.toString().replace(".", ""));
  r2 = Number(arg.toString().replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
};

// 数字转换mm-ss
Vue.prototype.timeTran = function(cuTime) {
  let cuMinute, cuSecond;
  if (cuTime > 0) {
    cuMinute = Math.floor(cuTime / 60);
    cuSecond = Math.floor(cuTime % 60);
    if (cuSecond > 9) {
      return cuMinute + ":" + cuSecond;
    }
    return cuMinute + ":0" + cuSecond;
  }
  return "00:00";
};

// 只能为数字和 . ;number (默认2位数) 用于 输入金额
Vue.prototype.handelNum = function(val, num) {
  typeof val == "number" ? (val = val.toString()) : ""; // 转成字符串类型

  num ? "" : (num = 2); // 默认两位小数

  let reg = new RegExp("\\d+" + (num > 0 ? "\\.?" : "") + "\\d{0," + num + "}");
  let match = val.match(reg); // 只能输入数字，小数最多两位

  // var reg = val.match(/\d+\.?\d*/); // 小数位数不限

  return match ? match[0].trim() : "";
};
/* ================================= 数字 end ========================================*/

/* ================================= input start ========================================*/
/** 控制input输入
 * 注意 ： 使用该函数需要在input定义 amount 属性 ，该方法的而数据以 input的amount属性值为准
 * 调用
 this.bindKeyEvent(e,'')
 */
Vue.prototype.bindKeyEvent = function(e, options) {
  let option = {
    num: 2,
    state: "keyup"
  };
  Object.assign(option, options);

  console.log(e, option, e.target.value);

  let val = e.target.value;

  if (option.state == "keyup") {
    return this.handelNum(val, option.num);
  }
};
/* ================================= input end ========================================*/

/* ================================= 图片 start ========================================*/
// 图片转base64
Vue.prototype.imgToBase64 = function(e, callback) {
  var that = e.target;
  // console.log(that, "ev");
  var maxLen = 1000;
  // var file = that.files[0];
  if (that.value) {
    if (!/.(gif|jpg|jpeg|png|GIF|JPG|png)$/.test(that.value)) {
      // util.alertU({title:"提示信息", message:"图片类型必须是.gif,jpeg,jpg,png中的一种"});
      this.$Message.error("图片类型必须是.gif,jpeg,jpg,png中的一种");
      $(that).val("");
      return false;
    } else {
      var reader = new FileReader();
      reader.onload = (function(file) {
        return function(e) {
          var url = this.result;
          // 超出1.5Mb大小需压缩
          var maxLen = 1572864;
          if (url.length > maxLen) {
            var img = new Image();
            img.src = url;
            img.onload = function() {
              //生成canvas
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0, img.width, img.height);
              var compressRate = maxLen / url.length;
              if (compressRate > 0.9) {
                compressRate = 0.9;
              }
              var base64 = canvas.toDataURL("image/jpeg", compressRate);
              while (base64.length / 1024 > 1536) {
                compressRate -= 0.02;
                base64 = canvas.toDataURL("image/jpeg", compressRate);
              }
              // var base64 = canvas.toDataURL('image/png', compressRate);
              callback(base64, file); // 这个就是base64的数据了
              console.log("base64", base64);
            };
          } else {
            callback(this.result, file); // 这个就是base64的数据了
            // console.log("this.result", this.result)
            $(that).val("");
          }
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    }
  }
};

// 上传图片文件
Vue.prototype.uploadFile = function(base64, callback, isLoading) {
  this.sendMessage(
    {
      method: "post",
      url: "/web/common/saveImage",
      data: { files: typeof base64 === "string" ? [base64] : base64 },
      tip: isLoading ? false : true
    },
    result => {
      console.log(result, "result");
      callback ? callback(result.data.data) : "";
    }
  );
};

/*用户头像处理*/
Vue.prototype.headerImg = function() {
  return store.state.user.userInfo.headPhoto
    ? this.getImgUrl(store.state.user.userInfo.headPhoto).replace(
        "&isGoods=1",
        ""
      )
    : "/static/img/img_user/Avatar@2x.png";
};

/*OCR识别*/
Vue.prototype.ocrRecognition = function(ocrType, base, callback) {
  let option = {
    url: "/web/aliocr/ocrInfo/" + ocrType
  };

  if (typeof base == "string") {
    option.data = { image: base };
  } else {
    Object.assign(option, base);
  }

  this.sendOther(option, result => {
    // console.log("ack回调", result);
    callback ? callback(result) : "";
  });
};

/*判断图片是否是base64格式*/
Vue.prototype.isBase64 = function(url) {
  // 判断url是base64格式还是图片的路径地址
  if (
    /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&‘,()*+;=\-._~:@\/?%\s]*?)\s*$/i.test(
      url
    )
  ) {
    // base64格式
    return true;
  }
  return false;
};
/* ================================= 图片 end ========================================*/

/* ================================= 文件 start ========================================*/
// 文件的范围限制
Vue.prototype.getScopeFile = function(e, callback) {
  var that = e.target;

  switch (that.dataset.filetype) {
    case "doc":
      if (!/.(doc|DOC|docx|DOCX)$/.test(that.value)) {
        this.$Message.error("文件类型必须是.doc、.docx中的一种");
        that.value = "";
        return false;
      }
      break;
    case "xlsx":
      if (!/.(xlsm|XLSM|xlsx|XLSX)$/.test(that.value)) {
        this.$Message.error("文件类型必须是.xlsm、.xlsx中的一种");
        that.value = "";
        return false;
      }
      break;
    case "pdf":
      if (!/.(pdf|PDF)$/.test(that.value)) {
        this.$Message.error("文件类型必须是.pdf、.PDF中的一种");
        that.value = "";
        return false;
      }
      break;
  }

  let maxLen = 3 * 1024 * 1024;
  if (that.value) {
    if (maxLen < that.files[0].size) {
      this.$Message.error("上传文件需要小于3M");
    } else {
      callback(that.files[0]);
    }
  }
};

// 上传其他文件
Vue.prototype.uploadFileOther = function(formData, callback, options) {
  let option = {
    url: "/web/common/uploadFile",
    data: formData,
    contentType: false,
    processData: false
  };

  Object.assign(option, options);

  this.sendMessage(option, result => {
    // console.log(result,"result")
    callback ? callback(result.data.data) : "";
  });
};

// 加载文字文件
/*
loadFont({
  name: 字体名称
  ttfUrl: 字体ttf文件地址
})
*/
Vue.prototype.loadFont = async function(fontFamily) {
  console.log("加载ttf字体：" + fontFamily.name);
  const font = new FontFace(fontFamily.name, "url(" + fontFamily.ttfUrl + ")");
  await font.load();
  document.fonts.add(font);
};

/* ================================= 文件 end ========================================*/

/* ================================= loading start ========================================*/
// 正在加载中
Vue.prototype.addLoading = function() {
  console.log("正在加载中");
  this.$Spin.show({
    render: h => {
      return h("div", [
        h("Icon", {
          class: "demo-spin-icon-load",
          props: {
            type: "ios-loading",
            size: 18
          }
        }),
        h("div", "Loading")
      ]);
    }
  });
};

// 删除正在加载中
Vue.prototype.removeLoading = function() {
  this.$Spin.hide();
};
/* ================================= loading end ========================================*/

/* ================================= 弹框处理 start ========================================*/
Vue.prototype.hidePopus = function() {
  store.state.showPopups = false;
  store.state.loginStatus = false;
  store.state.tipStatus = false;

  store.state.recharge_modal = false; // 充值服务费
  store.state.password_modal = false; // 更改登录密码
};

/* 公共的弹框的调用
  showTip({
    title: '',                            // 顶部title
    hideClose: '',                        // 是否隐藏关闭按钮
    closeStyle: '',                       // 关闭样式
    tipLogo: '',                          // 提示logo - tip_light - 红色灯泡；tip_prompt - 黄色！； tip_iconOk - 绿色√ ； tip_iconTime - 蓝色等待
    tipMessage: '提示内容',                // 提示信息
    tipClass: "",                         // 自定义类名 ， 此处是为了去除mb80 mt20这个效果

    tipButtonLeft: '',                    // 左按钮名称
    tipButtonLeftType: 'primary',         // 左按钮的类型
    tipButtonLeftClass: '',               // 左按钮类名
    tipButtonLeftCall: function () {},    // 左按钮回调

    tipButtonRight: '',                   // 右按钮名称
    tipButtonRightType: 'default',        // 右按钮类型
    tipButtonRightClass: '',              // 右按钮类名
    tipButtonRightCall: function () {},   // 右按钮回调

    closeCallback: '',                    // 关闭页面回调
  })
*/
Vue.prototype.showTip = function(options) {
  store.state.tipContent = Object.assign(
    {
      title: "", // 顶部title
      hideClose: "", // 是否隐藏关闭按钮
      closeStyle: "", // 关闭样式
      tipLogo: "", // 提示logo - tip_light - 红色灯泡；tip_prompt - 黄色！； tip_iconOk - 绿色√ ； tip_iconTime - 蓝色等待
      tipMessage: "提示内容", // 提示信息
      tipClass: "", // 自定义类名 ， 此处是为了去除mb80 mt20这个效果

      tipButtonLeft: "", // 左按钮名称
      tipButtonLeftType: "primary", // 左按钮的类型
      tipButtonLeftClass: "", // 左按钮类名
      tipButtonLeftCall() {}, // 左按钮回调

      tipButtonRight: "", // 右按钮名称
      tipButtonRightType: "default", // 右按钮类型
      tipButtonRightClass: "", // 右按钮类名
      tipButtonRightCall() {}, // 右按钮回调

      closeCallback: "" // 关闭页面回调
    },
    options
  );

  store.state.showPopups = true;
  store.state.tipStatus = true;
  console.log(store.state.tipContent, "store.state.tipContent");
};
/* ================================= 弹框处理 end ========================================*/

/* ================================= 代理商 start ========================================*/
/* 开户判断是否需要绑定代理商
 *
 */
Vue.prototype.agentEvent = function(options = {}) {
  let that = this;
  that.sendGet({
    url: "/web/discount-agent-customer/iscustomer",
    successCallback(result) {
      // console.log("ack回调", result);
      if (!result.data.data) {
        that.agentPopus(options);
      } else {
        options.other ? options.other() : "";
      }
    }
  });
};

/*快贴代理邀请
 * that 传入this指向
 * options
   successCallback 成功的回调
 */
Vue.prototype.agentPopus = function(options = {}) {
  let that = this;
  that.showTip({
    title: "开通快贴账户", // 顶部title
    tipMessage: `<div class='mb10 f20'>请填写您的邀请码</div>
                    <div class="f16 mb20">代理邀请码由官方认证的服务商提供</div>
                    <input id="invitationCode" class="w275 hl35 pl16 br3 bccc" placeholder="请在此处填写代理邀请码" />`, // 提示信息

    tipButtonLeft: "确认开户", // 左按钮名称
    closeStyle: 'invitationCodeClose',
    tipButtonLeftClass: 'invitationCodeBtn',
    closeStyle: 'invitationCodeClose',
    tipButtonLeftCall: function() {
      let code = document.getElementById("invitationCode").value;

      if (!code) {
        that.$Message.error("请输入代理人邀请码");
        return false;
      }

      that.addLoading();
      that.sendOther({
        url: "/web/discount-agent-customer/bind",
        data: {
          inviteType: "code",
          inviteCode: code
        },
        successCallback(result) {
          // console.log("ack回调", result);
          !options.tip ? that.$Message.success("绑定代理人成功") : "";
          that.hidePopus();

          options.success ? options.success() : "";
        }
      });
    }, // 左按钮回调

    tipButtonRight: "无邀请码？客服帮助", // 右按钮名称
    tipButtonRightCall: function() {
      handleCustomerBtn_qy();
    } // 右按钮回调
  });
};
/* ================================= 代理商 end ========================================*/

/* ================================= 样式 CSS start ========================================*/
/** CSS的添加和删除
 * 可以更改多个Class, 多个Class使用,隔开
 * 如果是在循环中调用的话，则需要添加[0]，如$refs['upload' + index][0]['classList']
 */
Vue.prototype.changeClass = function(ele, removeClass, addClass) {
  // console.log(ele, removeClass? removeClass: '', addClass?addClass:'');
  // console.log(removeClass.split(','))
  removeClass ? ele.remove(...removeClass.split(",")) : "";
  addClass ? ele.add(...addClass.split(",")) : "";
};
/* ================================= 样式 CSS end ========================================*/

/* ================================= 手机号 || code 验证 start ========================================*/
Vue.prototype.verifyMobile = function(mobile) {
  if (!mobile || mobile == "") {
    this.$Message.error("手机号不能为空");
    return false;
  }
  if (!/^(((1))+\d{10})$/.test(mobile)) {
    this.$Message.error("手机号码格式有误");
    return false;
  }
  return true;
};

Vue.prototype.verifyCode = function(code) {
  if (!code) {
    this.$Message.error("验证码不能为空");
    return false;
  }
  if (!/^\d{6}$/.test(code)) {
    this.$Message.error("验证码错误");
    return false;
  }
  return true;
};
/* ================================= 手机号验证 end ========================================*/

/* ================================= 微信链接分享 start ========================================*/
import wxapi from "@/assets/js/wxapi.js";

Vue.prototype.weixinShare = function(type) {
  let _this = this;
  let url = window.location.href;

  this.sendGet({
    url: `/web/wechatPublicPlatform/getWxConfigParams?url=${encodeURIComponent(
      encodeURIComponent(url)
    )}`,
    tip: false,
    successCallback: result => {
      console.log("url", url, "获取微信分享图片", result.data.data);

      // 获取配置的分享的信息
      _this.sendGet({
        url: `/web/share-page/type/${type}`,
        tip: false,
        successCallback: resultInfo => {
          console.log("获取微信分享配置信息", resultInfo.data.data);

          // data是微信配置信息，option是分享要配置的内容
          wxapi.wxRegister(result.data.data, {
            title: resultInfo.data.data.title, // 分享标题
            desc: resultInfo.data.data.content, // 分享描述
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              window.location.origin +
              _this.getImgUrl(resultInfo.data.data.logo), // 分享图标
            success: () => {
              console.log("微信分享设置成功！");
            },
            error: () => {
              console.log("微信分享设置失败！");
            }
          });
        },
        failCallback: resultInfo => {
          console.log("获取后台配置失败", resultInfo.message);
        }
      });
    },
    failCallback: result => {
      console.log("jssdk初始化失败", result.message);
    }
  });
};
/* ================================= 微信链接分享 end ========================================*/

/* ================================= APP下载 start ========================================*/

// 判断是安卓还是IOS
Vue.prototype.detect = function() {
  var equipmentType = "";
  var agent = navigator.userAgent.toLowerCase();
  var android = agent.indexOf("android");
  var iphone = agent.indexOf("iphone");
  var ipad = agent.indexOf("ipad");
  if (android != -1) {
    console.log("android");
    equipmentType = "android";
  }
  if (iphone != -1 || ipad != -1) {
    console.log("ios");
    equipmentType = "ios";
  }
  return equipmentType;
};

// 判断是否是微信或者微博环境
Vue.prototype.softEnviroment = function() {
  let ua = window.navigator.userAgent.toLowerCase();
  let isweixin = ua.match(/micromessenger/i) != null;
  let isweibo = ua.match(/weibo/i) == "weibo";
  if (isweixin) {
    return "weixin";
  } else if (isweibo) {
    return "weibo";
  }
  return "";
};

// IOS 的唤起
Vue.prototype.downloadIOSApp = function(
  urlScheme,
  storeURL,
  fallback,
  universalLink
) {
  var tid = this.deferFallback(3000, storeURL, fallback);
  let str = navigator.userAgent.toLowerCase();
  let list = str.match(/cpu iphone os (.*?) like mac os/);
  console.log(str, list);
  if (parseInt(list[1], 10) < 8) {
    this.bindPagehideEvent(tid);
  } else {
    this.bindVisibilityChangeEvent(tid);
  }
  if (parseInt(list[1], 10) > 8) {
    // 通过universalLink
    if (universalLink === undefined) {
      universalLink = urlScheme;
    } else {
      clearTimeout(tid);
    }
    this.vLocation(universalLink);
  } else {
    this.vIframe(urlScheme);
  }
};

// IOS 中的 可见性事件
Vue.prototype.bindPagehideEvent = function(tid) {
  window.addEventListener("pagehide", function clear() {
    if (this.isPageVisible()) {
      clearTimeout(tid);
      window.removeEventListener("pagehide", clear);
    }
  });
};

Vue.prototype.bindVisibilityChangeEvent = function(tid) {
  document.addEventListener("visibilitychange", function clear() {
    if (this.isPageVisible()) {
      clearTimeout(tid);
      document.removeEventListener("visibilitychange", clear);
    }
  });
};

Vue.prototype.isPageVisible = function() {
  var attrNames = ["hidden", "webkitHidden"];
  for (var i = 0, len = attrNames.length; i < len; i++) {
    if (typeof document[attrNames[i]] !== "undefined") {
      return !document[attrNames[i]];
    }
  }
  return true;
};

// 安卓 的唤起
Vue.prototype.deferFallback = function(timeout, storeURL, fallback) {
  var clickedAt = new Date().getTime();
  return setTimeout(function() {
    var now = new Date().getTime();
    if (Vue.prototype.isPageVisible() && now - clickedAt < timeout + 1000) {
      fallback(storeURL);
    }
  }, timeout);
};

// 打开页面的方式可能
// 1. 通过改变location
Vue.prototype.vLocation = function(urlScheme) {
  window.location.href = urlScheme;
};
// 2. 通过ifreame
Vue.prototype.vIframe = function(urlScheme) {
  setTimeout(() => {
    var iframe = this.createHiddenIframe("appLauncher");
    iframe.src = urlScheme;
  }, 100);
};
// 3. 通过intent
function vIntent(launchURI) {
  if (browser.name == "Chrome") {
    move();
  } else {
    setTimeout(move, 100);
  }

  function move() {
    // window.top.location.href = launchURI;
    window.location.href = launchURI;
  }
}

Vue.prototype.createHiddenIframe = function(id) {
  const ele = document.createElement("iframe");
  ele.id = id;
  ele.style.display = "none";
  document.documentElement.appendChild(ele);
  return ele;
};

/* ================================= APP下载 end ========================================*/

// 客服
Vue.prototype.handleCustomerBtn = function() {
  handleCustomerBtn_qy();
};

// 获取用户导航
Vue.prototype.userMenu = function(ack) {
  this.sendGet(
    {
      url: "/sysMenu/user"
    },
    result => {
      // console.log("ack回调", result);
      store.state.menuList = result.data.data;

      ack ? ack(result) : "";
    },
    result => {
      // console.log("其他回调", result);
    }
  );
};

// 表格排序
Vue.prototype.sortHandle = function(column) {
  // column.prop : 字段名称
  // column.order :  descending - 降序 || ascending - 升序  || null
  // console.log(column.prop, column.order);

  let asc = {
    descending: "desc",
    ascending: "asc"
  };

  let obj = {};

  if (column.order) {
    obj.sord = asc[column.order];
    obj.sidx = column.prop;
  } else {
    obj.sord = "";
    obj.sidx = "";
  }

  obj.page = 1;

  return obj;
};

// 格式化字典数据
Vue.prototype.formatDict = function(code, dictType, defaultVal) {
  if (store.state.publicData[dictType]) {
    return store.state.publicData[dictType][code];
  } else {
    return defaultVal || "---";
  }
};

//HTML反转义
Vue.prototype.HTMLDecode = function(s) {
  let temp = document.createElement("div");
  temp.innerHTML = s;
  let output = temp.innerText || temp.textContent;
  temp = null;
  return output;
};

Vue.prototype.textSlice = function(str) {
  str = this.HTMLDecode(str)
    .replace(/<\/?[^>]*>/g, "")
    .slice(0, 80);
  return str;
};

// 银行logo转换
// Vue.prototype.logoTransform = function (val) {
//   // console.log(val, arguments[1])
//   if(store.state.publicData.bankImg[val]) {
//     return store.state.publicData.bankImg[val];
//   }
//   return store.state.publicData.bankImg["default"];
// }

// 银行logo
Vue.prototype.logoStyle = function(val) {
  let banArr = [
    "FM",
    "WHLH",
    "YNHT",
    "HS",
    "MS",
    "NJ",
    "NB",
    "XY",
    "ZS",
    "PA",
    "ZX",
    "ZG",
    "JT",
    "JT2",
    "CS",
    "GF",
    "MT",
    "TL",
    "NY",
    "HZ",
    "NS",
    "PF",
    "GS",
    "JS",
    "SJ",
    "CZ",
    "QX",
    "JH",
    "ZY",
    "HX",
    "NCSY",
    "CJSY",
    "YZ",
    "GD",
    "ZY2",
    "MYBANK",
    "ZBANK",
    "ZHENX",
    "WZ",
    "FUMIN",
    "PINGAN",
    "SANXIANG",
    "BAIXIN",
    "HUARUN",
    "JDMR"
  ];

  if (banArr.indexOf(val) == -1) {
    val = "DEFAULT";
  }
  let logoUrl =
    process.env.OSSParam.endpoint + "/common/bank-img/logo/" + val + ".png";
  // return 'background-repeat: no-repeat;background-position: center center;background-size: contain;background-image: url(static/img/img_bank/' + val + '.png);';
  return (
    "background-repeat: no-repeat;background-position: center center;background-size: contain;background-image: url(" +
    logoUrl +
    ");"
  );
};

// 操作银行logo
Vue.prototype.operateBankLogoStyle = val => {
  let bankMap = {
    FM: "FM",
    WHLH: "WHLH",
    YNHT: "YNHT",
    HS: "HUI_SHANG",
    HUI_SHANG: "HUI_SHANG",
    MS: "MIN_SHENG",
    MIN_SHENG: "MIN_SHENG",
    NJ: "NAN_JING",
    NAN_JING: "NAN_JING",
    NB: "NING_BO",
    NING_BO: "NING_BO",
    XY: "XING_YE",
    ZS: "ZHAO_SHANG",
    ZHAO_SHANG: "ZHAO_SHANG",
    PA: "PING_AN",
    PING_AN: "PING_AN",
    ZX: "ZHONG_XIN",
    ZHONG_XIN: "ZHONG_XIN",
    ZG: "ZHONG_HANG",
    ZHONG_HANG: "ZHONG_HANG",
    JT: "JIAO_TONG",
    JIAO_TONG: "JIAO_TONG",
    JT2: "JIAO_TONG",
    CS: "CHANG_SHA",
    CHANG_SHA: "CHANG_SHA",
    GF: "GUANG_FA",
    GUANG_FA: "GUANG_FA",
    // "MT",
    TL: "TAI_LONG",
    TAI_LONG: "TAI_LONG",
    NY: "NONG_HANG",
    NONG_HANG: "NONG_HANG",
    HZ: "HANG_ZHOU",
    HANG_ZHOU: "HANG_ZHOU",
    NS: "WU_LU_MU_QI_SHANG_HANG",
    WU_LU_MU_QI_SHANG_HANG: "WU_LU_MU_QI_SHANG_HANG",
    PF: "PU_FA",
    PU_FA: "PU_FA",
    GS: "GONG_HANG",
    GONG_HANG: "GONG_HANG",
    JS: "JIAN_HANG",
    JIAN_HANG: "JIAN_HANG",
    SJ: "SHENG_JING",
    SHENG_JING: "SHENG_JING",
    CZ: "ZHE_SHANG",
    ZHE_SHANG: "ZHE_SHANG",
    // "QX",
    JH: "JIN_HUA",
    JIN_HUA: "JIN_HUA",
    ZY: "ZHONG_YUAN",
    ZHONG_YUAN: "ZHONG_YUAN",
    ZY2: "ZHONG_YUAN",
    HX: "HUA_XIA",
    HUA_XIA: "HUA_XIA",
    NCSY: "CHONG_QING_NONG_SHANG",
    CHONG_QING_NONG_SHANG: "CHONG_QING_NONG_SHANG",
    CJSY: "JIANG_SU_CHANG_JIANG",
    JIANG_SU_CHANG_JIANG: "JIANG_SU_CHANG_JIANG",
    YZ: "YOU_ZHENG",
    YOU_ZHENG: "YOU_ZHENG",
    GD: "GUANG_DA",
    GUANG_DA: "GUANG_DA",
    // JDMR: "JDMR",
    DEFAULT: "DEFAULT"
  };

  if (Object.keys(bankMap).indexOf(val) == -1) {
    val = "DEFAULT";
  }
  let logoUrl =
    process.env.OSSParam.endpoint +
    "/common/bank_icon/" +
    bankMap[val] +
    ".png";
  return (
    "background-repeat: no-repeat;background-position: center center;background-size: contain;background-image: url(" +
    logoUrl +
    ");"
  );
};

/*cookie*/
Vue.prototype.getCookie = function(name) {
  let arr = document.cookie.split(";");

  for (let i = 0; i < arr.length; i++) {
    let value = arr[i].trim();
    if (value.indexOf(name) == 0) {
      return value.substring(name.length, value.length);
    }
  }
  return "";
};

Vue.prototype.loadScript = function(src, callback) {
  const script = document.createElement('script'),
      head = document.getElementsByTagName('head')[0];
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.src = src;
  if (script.addEventListener) {
      script.addEventListener('load', function () {
          callback();
      }, false);
  } else if (script.attachEvent) {
      script.attachEvent('onreadystatechange', function () {
          const target = window.event.srcElement;
          if (target.readyState == 'loaded') {
              callback();
          }
      });
  }
  head.appendChild(script);
}

/*====================自定义指令=============================================*/
// 限制只能输入数字，不能带小数点：使用v-number-only
Vue.directive("numberOnly", {
  bind: function(el) {
    el.handler = function(e) {
      e.target.value = e.target.value.replace(/\D+/, "");
      e.target.dispatchEvent(new Event("input")); //调用input事件使vue v-model绑定更新,下面相同
    };
    // el.addEventListener('input', el.handler);
    el.addEventListener("keyup", el.handler);
  }
});

// 限制只能输入数字，可以带小数点：使用v-double-only
Vue.directive("doubleOnly", {
  bind: function(el) {
    el.handler = function(e) {
      // e.target.value = e.target.value.replace(/\D+/, '');
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || "";
      e.target.dispatchEvent(new Event("input")); //调用input事件使vue v-model绑定更新,下面相同
    };
    // el.addEventListener('input', el.handler);
    el.addEventListener("keyup", el.handler);
  }
});

/**
 * v-text-only="{
 *   textType: '', // 需要限制是什么文本类型：num：限制只能是数字；double：限制只能是小数；regExp：限制根据自定义的正则表达式的规则来写
 *   doublePointNum: '', // 在textType是double类型下有效。表示限制小数点后有几位数
 *   regExp: '', // 在textType是regExp类型下有效。表示自定义的正则表达式的规则
 * }"
 */
Vue.directive("textOnly", {
  bind: function(el, binding) {
    el.handler = function(e) {
      switch (binding.value.textType) {
        case "num":
          // 数字类型
          e.target.value = e.target.value.replace(/\D+/, "");
          e.target.value = e.target.value ? e.target.value : "";
          break;
        case "double": {
          const regexp = "^\\d*(\\.?\\d{0,{{doublePointNum}}})".replace(
            /{{doublePointNum}}/g,
            binding.value.doublePointNum || 2
          );
          e.target.value =
            e.target.value.match(new RegExp(regexp, "g"))[0] || "";
          break;
        }
        case "regExp":
          e.target.value =
            e.target.value.match(new RegExp(binding.value.regExp, "g"))[0] ||
            "";
          break;
      }
      console.log("max", binding.value.max);
      if (binding.value.max !== undefined) {
        if (Number(e.target.value) > Number(binding.value.max)) {
          e.target.value = binding.value.max;
        }
      }
      // e.target.dispatchEvent(new Event("input")); // 调用input事件使vue v-model绑定更新

      // 兼容IE浏览器写法
      var event2 = document.createEvent("HTMLEvents");
      event2.initEvent("input", false, true);
      e.target.dispatchEvent(event2); // 调用input事件使vue v-model绑定更新
    };
    el.addEventListener("keyup", el.handler);
  }
});

// 加入百度统计
if (process.env.EVN_CONFIG == "prod") {
  var _hmt = _hmt || [];
  window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?8fb598c159c41200b4c36eedb9ae365f";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

  router.beforeEach((to, from, next) => {
    if (to.path && window._hmt) {
      // console.log('_hmt', window._hmt, to.fullPath)
      window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
    }
    next();
  });
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js